import type { ProgramPurseResource } from '@/queries/program_purses/schemas'

const SPECIAL_NEEDS_CODE = 'special_education' as const

export type ModifierGroup =
  ProgramPurseResource['distributions_rules']['distribution_modifiers']

export function groupModifiersByCode(modifiers: ModifierGroup) {
  return modifiers.reduce(
    (acc, modifier) => {
      const bucket = acc[modifier.modifier_code] ?? []
      bucket.push(modifier)
      acc[modifier.modifier_code] = bucket
      return acc
    },
    {} as Record<string, ModifierGroup>
  )
}

export function getNonGradeBasedModifiers(
  modifiersByCode: Record<string, ModifierGroup>
) {
  return Object.fromEntries(
    Object.entries(modifiersByCode).filter(
      ([code]) => code !== SPECIAL_NEEDS_CODE
    )
  )
}
